import React from 'react';
import { useTranslation } from 'react-i18next';

export const PassiveBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="relative flex flex-col h-[25.4rem] overflow-hidden bg-white-40 border-[0.1rem] border-solid border-white-50 rounded-[3rem] p-[6rem] backdrop-blur-[1.5rem] lg:h-[44rem] lg:px-[2rem] lg:py-[4rem] lg:items-center">
      <span className="text-[6rem] text-white font-500 tracking-[-1.2px] z-[2] mb-[2rem] leading-[6rem] lg:text-[3.2rem] lg:tracking-[-0.64px] lg:leading-[3.2rem] lg:mb-[1.6rem]">
        {t('passive.banner.title')}
      </span>
      <span className="text-[1.8rem] leading-[2.7rem] text-white-500 z-[2] tracking-[-0.36px] max-w-[40.2rem] lg:max-w-full lg:text-[1.6rem] lg:leading-[2.4rem] lg:tracking-[-0.32px] lg:text-center">
        {t('passive.banner.description')}
      </span>
      <img src="/images/passive/banner/shadow.webp" className="absolute top-0 right-0 h-full z-[0]" />
      <img src="/images/passive/banner/shadowTop.webp" className="absolute top-0 left-0 z-[1]" />
      <img
        src="/images/passive/banner/coins.webp"
        className="absolute top-[-1rem] right-[3.2rem] z-[1] w-[53rem] lg:w-[34.4rem] lg:right-auto lg:left-1/2 lg:-translate-x-1/2 lg:top-auto lg:bottom-[-10rem]"
      />
    </div>
  );
};
